import WindowSizeHelper from './WindowSizeHelper';

export default class DynamicElementPositionHelper {
  static isInViewportX(x, elementWidth) {
    return WindowSizeHelper.getClientWidth() > x + elementWidth;
  }

  static isInViewportY(y, elementHeight) {
    return WindowSizeHelper.getClientHeight() > y + elementHeight;
  }
}
